import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Mantine + @medplum/react styles power the wrapped @medplum/react components
// (behind wrappers only; the ACTO chrome itself is Tailwind).
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@medplum/react/styles.css';

// ACTO chrome tokens + Tailwind.
import './index.css';

import { App } from './App';
import { AppProviders } from './components/providers/AppProviders';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>
);
